// Bilingual PT/EN toggle, site-wide — ports the instant client-side language
// switch from LanguageContext.tsx (React useState, no page reload). Every
// translatable string is rendered twice in the DOM ([data-lang-pt] /
// [data-lang-en]); this script shows the active one and hides the other via
// the native `hidden` attribute.
//
// The choice is saved to localStorage so it survives navigation between the
// site's static pages (each is a full page load, not a SPA route) — without
// this, every new page reset back to Portuguese regardless of what the
// customer picked on the homepage.
(function () {
  var STORAGE_KEY = 'conquistador-lang';

  function getSavedLang() {
    try {
      return localStorage.getItem(STORAGE_KEY);
    } catch (e) {
      return null;
    }
  }

  function setLang(lang, persist) {
    document.documentElement.setAttribute('data-lang', lang);
    document.querySelectorAll('[data-lang-pt]').forEach(function (el) { el.hidden = lang !== 'pt'; });
    document.querySelectorAll('[data-lang-en]').forEach(function (el) { el.hidden = lang !== 'en'; });
    document.querySelectorAll('[data-lang-btn]').forEach(function (btn) {
      btn.classList.toggle('is-active', btn.getAttribute('data-lang-btn') === lang);
    });
    if (persist) {
      try { localStorage.setItem(STORAGE_KEY, lang); } catch (e) {}
    }
    document.dispatchEvent(new CustomEvent('langchange', { detail: { lang: lang } }));
  }

  function init() {
    document.querySelectorAll('[data-lang-btn]').forEach(function (btn) {
      btn.addEventListener('click', function () { setLang(btn.getAttribute('data-lang-btn'), true); });
    });
    setLang(getSavedLang() || 'pt', false);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
